import { useSyncExternalStore } from 'react';

import { getTheme, setTheme, subscribeTheme, toggleTheme, type Theme } from './theme';

/**
 * Subscribe to the stored theme preference (see `./theme`). Returns the live
 * value plus the setters, so a component re-renders when any other part of the
 * app — or another browser tab — flips it.
 */
export function useTheme(): {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
} {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, getTheme);
  return { theme, setTheme, toggleTheme };
}
